<template>
  <page-outline :title="'Détails du document'">
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <form-accordion :title="'Informations'">
          <b-row>
            <b-col sm="4">
              <form-read-group-label-input :inputLabel="$t('common.type_doc')"
                :inputValue="entity.type_doc">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="4">
              <form-read-group-label-input :inputLabel="$t('common.file_name')"
                :inputValue="entity.file_name">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="4">
              <form-read-group-label-input :inputLabel="$t('common.date_label')"
                :inputValue="dateFormat(entity.end_time)">
              </form-read-group-label-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="12">
              <form-read-group-label-input :inputLabel="$t('common.errors')"
                :inputValue="'Les champs suivants ont été retournés vides: ' + displayErrors(entity.errors)">
              </form-read-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>
        <form-accordion :title="'Données collectées'" class="mt-5">
          <b-row>
            <b-col sm="4" v-for="(value, key) of Object.entries(entity.json_data)" :key="key" class="mt-2">
              <form-read-group-label-input :inputLabel="$t('businessDocuments.serialize.' + entity.type_doc + '.' + value[0])"
                :inputValue="value[1]">
              </form-read-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>
      </div>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import moment from 'moment'
import PageOutline from '@/components/common/PageOutline.vue'
import spinner from '@/components/common/spinner.vue'

export default {
  name: 'VerificationsDetailPage',
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': spinner
  },
  data () {
    return {
      activateSpinner: true,
      result: {},
      date: '',
      name: '',
      postalCode: '',
      townName: '',
      address: '',
      iban: '',
      bic: '',
      bankDomiciliation: ''
    }
  },
  created () {
    this.activateSpinner = true
    this.entity = this.$engine.ocr.selectedResult
    this.activateSpinner = false
  },
  methods: {
    dateFormat (str) {
      return moment(str).format('DD/MM/yyyy HH:mm:ss')
    },
    displayErrors (str) {
      let errorStr = ''
      const errors = {'_21': 'nom', '_22': 'code postal', '_23': 'ville', '_24': 'adresse', '_25': 'IBAN', '_29': 'BIC', '_211': 'domiciliation bancaire'}
      Object.keys(errors).forEach(errorCode => {
        if (str.includes(errorCode)) {
          if (errorStr !== '') {
            errorStr += ', '
          }
          errorStr += errors[errorCode]
        }
      })
      return errorStr
    },
    get_key (str) {
      Object.keys(str)[0]
    }
  }
}
</script>

<style>
.resultsVerifications td {
  white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// OCRScanDetailPage.vue?91410c46